import { Watch } from '@schematics/angular/third_party/github.com/Microsoft/TypeScript/lib/typescript';
import { Watchers } from './watchers.model';

export interface WeeklyReportResponse {
  status: string;
  message: string;
  error_code: number | null;
  meta_data: {
    current_page: number;
    per_page: number;
    total_pages: number;
    total_items: number;
  };
  data: WeeklyReport[];
  errors: any | null;
}

export interface WeeklyReport {
  id: string;
  project_id: string;
  name: string;
  deviation: string;
  achievements_description: Achievements[];
  challenges_description: Challenges[];
  creator_id: number;
  start_date: string;
  end_date: string;
  created_at: string;
  remaining_cost: string;
  creator_name: string;
  updated_at: string;
}

export interface Achievements {
  description: string;
  status: string;
  date: string;
}

export interface Challenges {
  description: string;
  neededAction: string;
  closing_date: string;
}

export interface LastPhaseResponse {
  status: string;
  message: string;
  error_code: null | number;
  meta_data: null | any;
  data: PhaseData;
  errors: null | any;
}

export interface PhaseData {
  phase_id: string;
  short_id: string;
  planned_cost: null | number;
  actual_cost: null | number;
  project_cost: {
    planned_cost: number;
    actual_cost: number;
    differenceCost: number;
    spent_cost_percentage: number;
  };
  project_completion_percentage: string;
  created_by: string;
  phase_name: string;
  phase_desc: null | string;
  start_date: string;
  end_date: string;
  weight: string;
  progress: string;
  status: string;
  reports: Report[];
  attached: any[];
}

interface Report {
  id: string;
  phase_id: string;
  progress_id: string | null;
  user_id: string;
  report_id: string;
  deleted_at: null | string;
  created_at: string;
  updated_at: string;
}

export interface WeeklyReportDetailResponse {
  status: string;
  message: string;
  error_code: null;
  meta_data: null;
  data: WeeklyReportDetail;
  errors: null;
}

export interface WeeklyReportDetail {
  id: string;
  project_id: string;
  project_name: string;
  name: string;
  deviation: string;
  achievements_description: {
    description: string;
    status: string;
    date: string;
  }[];
  challenges_description: {
    description: string;
    actionNeeded: string;
    date: string;
    status: string;
  }[];
  creator_id: number;
  creator_name: string;
  start_date: string;
  end_date: string;
  project_manager_name: string;
  created_at: string;
  updated_at: string;
  actual_progress_percentage: string;
  pending_cost: string;
  planned_progress_percentage: string;
  actual_cost: string;
  remaining_cost: string;
  financial_input_type?: 'sar' | 'percentage'; // Add financial input type field
  contractor_image: string;
  consultant_image: string;
  supervision_image: string;
  project_cost: {
    planned_cost: number;
    actual_cost: number;
    differenceCost: number;
    spent_cost_percentage: number;
  };
}

export interface WeeklyReportCommentResponse {
  status: string;
  message: string;
  error_code: null;
  meta_data: {
    current_page: number;
    per_page: number;
    total_pages: number;
    total_items: number;
  };
  data: WeeklyReportComment[];
  errors: null;
}

export interface WeeklyReportComment {
  id: string;
  replied_by: string;
  type: string;
  text_reply: string;
  replied_at: string;
  reply_attached: any[];
  mentions: any[];
}

export interface WeeklyReportMentionableUsersResponse {
  status: string;
  message: string;
  error_code: null;
  meta_data: null;
  data: Watchers[];
  errors: null;
}

export interface MentionableUser {
  id: number;
  uuid: string;
  client_id: string;
  name: string;
  email: string;
  phone_number: string;
  status: number;
  preferences: null;
}
